import { FeatureFlag, SiteInfo } from '@cbo/shared-library';
import useSiteContext from '../../org/SiteContext';
import { useSites } from '../../contexts/siteContext';
import { SiteSwitcherOptions } from '../../org/SiteSwitcher/SiteSwitcher';
import { useFeatureFlag } from './useFeatureFlag';

function useCurrentSite() {
  const { selectedSite, lastSelectedSite, sortedSites } = useSites();
  const { selectedSite: bslSelectedSite } = useSiteContext();
  const isBslSiteSwitcherEnabled = useFeatureFlag(FeatureFlag.siteSwitcher);
  const bslSiteId: string | undefined =
    bslSelectedSite?.id !== SiteSwitcherOptions.ORGANIZATION_VIEW ? bslSelectedSite?.id : selectedSite.enterpriseUnitId;
  const shouldUseBslSite =
    isBslSiteSwitcherEnabled && process.env.REACT_APP_USE_PREVIEW_ORG_SWITCHER !== 'true' && bslSiteId;
  let siteId: string = shouldUseBslSite ? bslSiteId : selectedSite.enterpriseUnitId;
  if (!shouldUseBslSite && selectedSite.enterpriseUnitId === '') {
    siteId = lastSelectedSite.enterpriseUnitId;
  }
  const isOrgLevelView = shouldUseBslSite
    ? bslSelectedSite?.id === SiteSwitcherOptions.ORGANIZATION_VIEW
    : selectedSite?.id === SiteSwitcherOptions.ORGANIZATION_VIEW;
  const currentSite: SiteInfo =
    shouldUseBslSite && bslSelectedSite
      ? {
          ...bslSelectedSite,
          name: bslSelectedSite.eu_name,
          enterpriseUnitId: bslSelectedSite.id,
        }
      : selectedSite;
  const totalSites = sortedSites?.length || 0;
  const currentSiteId = shouldUseBslSite && bslSelectedSite ? bslSelectedSite?.id : selectedSite.enterpriseUnitId;
  siteId = siteId === SiteSwitcherOptions.ORGANIZATION_VIEW ? sortedSites[0]?.enterpriseUnitId : siteId;
  return {
    siteId,
    currentSite,
    isOrgLevelView,
    isSingleSiteOrg: totalSites === 1,
    totalSites,
    canEditPage: isOrgLevelView || totalSites === 1,
    currentSiteId,
  };
}

export default useCurrentSite;
